import React, { useRef, useEffect, useState } from "react";

import Button from "../button/index.js";
import Columns from "../columns/index.js";

const Code = ({ children }) => {
  const codeRef = useRef(null);
  const [copyButtonLabel, setCopyButtonLabel] = useState("Copy Code");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setCopyButtonLabel("Copy Code");
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, [copyButtonLabel]);

  return (
    <Columns numberOfColumns={1}>
      <pre>
        <code ref={codeRef}>{children}</code>
      </pre>
      <Button
        label={copyButtonLabel}
        onClick={() => {
          const el = document.createElement("textarea");
          el.value = codeRef.current.innerText;
          document.body.appendChild(el);
          el.select();
          document.execCommand("copy");
          document.body.removeChild(el);
          setCopyButtonLabel("Copied!");
        }}
        size="small"
      />
    </Columns>
  );
};

export default Code;
